import React from "react";
import { useTheme } from "@material-ui/core/styles";
import {
  Box,
  Card,
  CardContent,
  Drawer,
  Paper,
  Typography,
} from "@material-ui/core";
import { nodeCategories } from "../FlowBuilder/nodeCategoriesConfig";
import { useStyles } from "../FlowBuilder/flowEditorStyles";

const NodePalette = ({ onAddNode, mobileOpen, onDrawerClose, provider }) => {
  const classes = useStyles();
  const theme = useTheme();

  // Nodos marcados wabaOnly solo se muestran en flujos WABA (0371 WF5).
  const isWaba = String(provider || "").toLowerCase() === "waba";
  const isVisible = (node) => !node.wabaOnly || isWaba;

  const renderNodes = () => (
    <>
      {Object.entries(nodeCategories).map(([categoryKey, category]) => {
        const nodes = category.nodes.filter(isVisible);
        if (nodes.length === 0) return null;
        return (
        <Box key={categoryKey}>
          <Typography className={classes.categoryTitle}>
            {category.title}
          </Typography>
          {nodes.map((node) => (
            <Card
              key={node.type}
              className={classes.nodeCard}
              onClick={() => onAddNode(node.type)}
              elevation={0}
            >
              <CardContent className={classes.nodeCardContent}>
                <Box
                  style={{
                    color:
                      categoryKey === "bubbles"
                        ? theme.palette.type === "dark"
                          ? "white"
                          : theme.palette.primary.main
                        : categoryKey === "inputs"
                        ? "#ff6b35"
                        : categoryKey === "contenedor"
                        ? "#5c35d4"
                        : "#9c88ff",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {node.icon}
                </Box>
                <Typography className={classes.nodeLabel}>
                  {node.label}
                </Typography>
              </CardContent>
            </Card>
          ))}
        </Box>
        );
      })}
    </>
  );

  return (
    <>
      {/* Sidebar desktop/tablet — hidden on xs via CSS */}
      <Paper className={classes.sidebar} elevation={0}>
        {renderNodes()}
      </Paper>

      {/* Drawer mobile — xs only */}
      <Drawer
        anchor="left"
        open={mobileOpen}
        onClose={onDrawerClose}
        ModalProps={{ keepMounted: true }}
      >
        <Box className={classes.sidebarContent} onClick={onDrawerClose}>
          {renderNodes()}
        </Box>
      </Drawer>
    </>
  );
};

export default NodePalette;
